import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from "js-cookie"

import locationStore from './locationStore'
import routeStore from './routeStore'
import stationStore from './stationStore'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    locationStore,
    routeStore,
    stationStore
  },
  plugins: [
      createPersistedState({ storage: window.sessionStorage })
  ],
  strict: debug
})



// WEBPACK FOOTER //
// ./Resources/Private/JavaScript/store/store.js